import { SharedAccessesForTaskDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface SharedAccessesData {
  id: number
  avatar?: string | null
  fullName: string
  jobTitle?: string | null
}

export const useSharedAccessesForTask = (taskId: number) => {
  const { data, loading } = useQuery(SharedAccessesForTaskDocument, {
    variables: { taskId },
    fetchPolicy: 'network-only',
  })

  const formatData = (): SharedAccessesData[] => {
    return (
      data?.tasks.shareTasksConnection.edges[0]?.node.accessesConnection.edges.map(({ node }) => {
        return {
          id: node.id,
          avatar: node.avatar,
          fullName: node.fullName,
          jobTitle: node.employee?.contractversionsConnection.edges[0]?.node.jobTitle,
        }
      }) || []
    )
  }

  return {
    loading,
    accesses: data ? formatData() : [],
  }
}
